import React from 'react';
import {NavLink} from "react-router-dom";
import {FORGOT_PASSWORD_ROUTE, REGISTER_ROUTE} from "../../util/Constants";

const LoginForm = ({data, setData, authorize, handleEnterPress, invalid, oauthFooter}) => {
    return (
        <div className="w-full max-w-md rounded-3xl border border-stone-200/70 bg-white/95 p-8 shadow-soft backdrop-blur-sm">
            <h2 className="text-center text-2xl font-semibold tracking-tight text-bark-900">Вход</h2>
            {invalid ? (
                <p className="mt-3 rounded-2xl bg-red-50 px-3 py-2 text-center text-sm text-red-700">{invalid}</p>
            ) : null}
            <div className="mt-6 flex flex-col gap-4">
                <div>
                    <label className="lut-label">Email</label>
                    <input
                        className="lut-input"
                        placeholder="email"
                        value={data.email}
                        onChange={(e) => setData({...data, email: e.target.value})}
                        type="email"
                        autoComplete="email"
                        onKeyUp={handleEnterPress}
                    />
                </div>
                <div>
                    <label className="lut-label">Пароль</label>
                    <input
                        className="lut-input"
                        placeholder="пароль"
                        type="password"
                        value={data.password}
                        onChange={(e) => setData({...data, password: e.target.value})}
                        autoComplete="current-password"
                        onKeyUp={handleEnterPress}
                    />
                </div>
                <div className="flex flex-col gap-3 pt-2 sm:flex-row sm:items-center sm:justify-between">
                    <button type="button" onClick={authorize} className="lut-btn-pine order-2 sm:order-1">
                        Войти
                    </button>
                    <div className="order-1 flex flex-col gap-1 text-sm text-bark-600 sm:order-2 sm:text-right">
                        <span>Нет аккаунта? <NavLink to={REGISTER_ROUTE} className="font-medium text-pine-700 hover:underline">Регистрация</NavLink></span>
                        <NavLink to={FORGOT_PASSWORD_ROUTE} className="text-pine-700 hover:underline">Забыли пароль?</NavLink>
                    </div>
                </div>
            </div>
            {oauthFooter}
        </div>
    );
};

export default LoginForm;
